export const LENSES_AMOUNT_MIN = '0';
export const LENSES_AMOUNT_MAX = '100';
export const LENSES_AMOUNT_ONE = 1;
